<template>
  <SubNav class="subnav-position" :selected="'updates'" :id="id" />
  <main>
    <form @submit.prevent="handleSubmit" class="shadow edit-form">
      <div class="float-end">
        <router-link :to="{ name: 'OfferingUpdates', params: { id: id } }"
          ><h4>&times;</h4></router-link
        >
      </div>
      <h6>Create Update</h6>
      <div class="form-outline mb-4">
        <label>Title</label>
        <input type="text" required v-model="title" class="form-control" />
      </div>
      <div class="form-outline mb-4">
        <label>Update</label>
        <textarea v-model="description" class="form-control"> </textarea>
      </div>
      <div class="error">{{ formError }}</div>
      <div v-if="!isPending" class="row text-center">
        <div class="col">
          <button class="btn btn-primary">Create</button>
        </div>
        <div class="col">
          <router-link
            :to="{ name: 'OfferingUpdates', params: { id: id } }"
            class="btn btn-secondary"
          >
            Cancel
          </router-link>
        </div>
      </div>
      <div v-else>
        <button class="btn btn-secondary" disabled>
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Creating...</span>
          </div>
        </button>
      </div>
    </form>
  </main>
  <Footer />
</template>

<script>
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import useCollection from "@/composables/useCollection";
import { timestamp } from "@/firebase/config";
import getUser from "@/composables/getUser.js";
import SubNav from "@/components/navigation/SubNav.vue";
import { format } from "date-fns";
import Footer from "@/components/navigation/Footer.vue";

export default {
  props: ["id"],
  components: { SubNav, Footer },
  setup(props) {
    const title = ref("");
    const description = ref("");
    const formError = ref("");
    const isPending = ref(false);
    const { user } = getUser();
    const { error, addDoc } = useCollection("offeringUpdates");
    const router = useRouter();

    const handleSubmit = async () => {
      try {
        isPending.value = true;
        formError.value = null;
        const ref = await addDoc({
          date: format(new Date(), "MMM d, uuuu"),
          title: title.value,
          description: description.value,
          issuerId: user.value.uid,
          offeringId: props.id,
          createdAt: timestamp()
        });
        isPending.value = false;
        if (error.value) {
          formError.value = error.value;
        } else {
          router.push({
            name: "EditUpdate",
            params: { id: props.id, updateId: ref.id }
          });
        }
      } catch (err) {
        formError.value = "System Error: " + err.message;
      }
    };

    return { title, description, formError, isPending, handleSubmit };
  }
};
</script>

<style>
</style>